import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-96">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-97">
          <div className="absolute inset-0 bg-charcoal/70 backdrop-blur-sm" data-id="element-98" />
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.25
      }} onClick={e => e.stopPropagation()} className="relative bg-cream-50 text-charcoal w-full max-w-2xl max-h-[80vh] overflow-y-auto shadow-2xl" data-id="element-99">
            <div className="sticky top-0 bg-cream-50 border-b border-cream-300 px-6 py-4 flex items-center justify-between z-10" data-id="element-100">
              <h3 className="text-lg font-display font-medium" data-id="element-101">{title}</h3>
              <button onClick={onClose} className="p-1 hover:text-terracotta-400 transition-colors" aria-label="Cerrar" data-id="element-102">
                <XIcon className="h-5 w-5" data-id="element-103" />
              </button>
            </div>
            <div className="px-6 py-6 text-sm font-light leading-relaxed space-y-4 text-charcoal/80" data-id="element-104">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-charcoal text-cream-100 py-12 border-t border-olive-900" data-id="element-105">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center md:items-start text-center md:text-left" data-id="element-107">
            <div className="flex flex-col items-center md:items-start" data-id="element-108">
              <div className="flex flex-col items-center md:items-start leading-none mb-6" data-id="element-109">
                <span className="text-2xl font-display font-medium tracking-[0.25em] text-cream-100" data-id="element-110">
                  TERRACOTTA
                </span>
                <span className="text-[0.7rem] font-body font-light tracking-[0.45em] uppercase mt-1 text-cream-300" data-id="element-111">
                  ATELIER
                </span>
              </div>
              <p className="text-sm font-light text-cream-100/60 max-w-xs" data-id="element-112">
                Deja de comprar ropa. Empieza a construir imagen.
              </p>
            </div>

            <div className="flex flex-col space-y-3" data-id="element-113">
              <h4 className="font-display text-lg text-cream-50 mb-2" data-id="element-114">
                Navegación
              </h4>
              <a href="#problema" className="text-sm font-light hover:text-terracotta-400 transition-colors" data-id="element-115">
                El Problema
              </a>
              <a href="#solucion" className="text-sm font-light hover:text-terracotta-400 transition-colors" data-id="element-116">
                La Solución
              </a>
              <a href="#tienda" className="text-sm font-light hover:text-terracotta-400 transition-colors" data-id="element-117">
                La Tienda
              </a>
              <a href="#contacto" className="text-sm font-light hover:text-terracotta-400 transition-colors" data-id="element-118">
                Contacto
              </a>
            </div>

            <div className="flex flex-col space-y-3" data-id="element-119">
              <h4 className="font-display text-lg text-cream-50 mb-2" data-id="element-120">
                Contacto
              </h4>
              <p className="text-sm font-light" data-id="element-121">Cl. 27 Nte. #6AN-19</p>
              <p className="text-sm font-light" data-id="element-122">
                Santa Monica Residencial, Cali
              </p>
              <a href="https://wa.me/573160551859?text=Quiero%20construir%20mi%20imagen" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-terracotta-400 hover:text-terracotta-500 transition-colors mt-2" data-id="element-123">
                WhatsApp: 316 055 1859
              </a>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-olive-900/50 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-124">
            <p className="text-xs font-light text-cream-100/40" data-id="element-125">
              © 2026 Terracotta Atelier. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-4" data-id="element-126">
              <button onClick={() => setShowPrivacy(true)} className="text-xs font-light text-cream-100/40 hover:text-cream-100/70 transition-colors" data-id="element-127">
                Política de Privacidad
              </button>
              <span className="text-cream-100/20" data-id="element-128">|</span>
              <button onClick={() => setShowTerms(true)} className="text-xs font-light text-cream-100/40 hover:text-cream-100/70 transition-colors" data-id="element-129">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-130">
        <p className="font-medium text-charcoal" data-id="element-131">
          Última actualización: Marzo 2026
        </p>
        <p data-id="element-132">
          En Terracotta Atelier, respetamos tu privacidad y nos comprometemos a
          proteger tus datos personales. Esta política describe cómo
          recopilamos, usamos y protegemos tu información.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-133">
          1. Información que Recopilamos
        </h4>
        <p data-id="element-134">
          Recopilamos información que nos proporcionas directamente, como tu
          nombre, número de teléfono y preferencias de estilo cuando nos
          contactas por WhatsApp o visitas nuestra tienda. No recopilamos datos
          de navegación ni utilizamos cookies de seguimiento.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-135">
          2. Uso de la Información
        </h4>
        <p data-id="element-136">Utilizamos tu información exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-137">
          <li data-id="element-138">Brindarte atención personalizada y asesoría de imagen</li>
          <li data-id="element-139">Comunicarnos contigo sobre tu visita o consulta</li>
          <li data-id="element-140">
            Informarte sobre nuevas colecciones o eventos (solo si lo autorizas)
          </li>
        </ul>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-141">
          3. Protección de Datos
        </h4>
        <p data-id="element-142">
          Tu información personal se almacena de forma segura y no se comparte
          con terceros bajo ninguna circunstancia. Cumplimos con la Ley 1581 de
          2012 de Protección de Datos Personales de Colombia.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-143">
          4. Tus Derechos
        </h4>
        <p data-id="element-144">
          Tienes derecho a conocer, actualizar, rectificar y solicitar la
          eliminación de tus datos personales en cualquier momento. Para ejercer
          estos derechos, contáctanos al 316 055 1859.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-145">
          5. Contacto
        </h4>
        <p data-id="element-146">
          Para cualquier consulta sobre esta política, escríbenos al WhatsApp
          316 055 1859 o visítanos en Cl. 27 Nte. #6AN-19, Santa Monica
          Residencial, Cali.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-147">
        <p className="font-medium text-charcoal" data-id="element-148">
          Última actualización: Marzo 2026
        </p>
        <p data-id="element-149">
          Al visitar nuestra tienda o contactarnos a través de nuestros canales,
          aceptas los siguientes términos y condiciones.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-150">
          1. Sobre Nuestros Productos
        </h4>
        <p data-id="element-151">
          Terracotta Atelier ofrece blazers y camisas curados para la mujer
          profesional. Todas las prendas están sujetas a disponibilidad. Los
          colores pueden variar ligeramente debido a la iluminación o
          configuración de pantalla.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-152">
          2. Precios y Pagos
        </h4>
        <p data-id="element-153">
          Los precios están expresados en pesos colombianos (COP) e incluyen
          IVA. Aceptamos efectivo, transferencias bancarias y pagos con tarjeta.
          Los precios pueden cambiar sin previo aviso.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-154">
          3. Cambios y Devoluciones
        </h4>
        <p data-id="element-155">
          Aceptamos cambios dentro de los 5 días hábiles siguientes a la compra,
          presentando el recibo y con la prenda en perfectas condiciones, sin
          uso y con etiquetas originales. No realizamos devoluciones de dinero.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-156">
          4. Asesoría de Imagen
        </h4>
        <p data-id="element-157">
          La asesoría de imagen incluida es un servicio complementario ofrecido
          en tienda. Las recomendaciones son orientativas y basadas en nuestra
          experiencia profesional.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-158">
          5. Propiedad Intelectual
        </h4>
        <p data-id="element-159">
          Todo el contenido de este sitio web, incluyendo textos, imágenes y
          diseño, es propiedad de Terracotta Atelier y está protegido por las
          leyes de propiedad intelectual de Colombia.
        </p>

        <h4 className="font-display text-base font-medium text-charcoal pt-2" data-id="element-160">
          6. Contacto
        </h4>
        <p data-id="element-161">
          Para cualquier consulta sobre estos términos, contáctanos al WhatsApp
          316 055 1859 o visítanos en Cl. 27 Nte. #6AN-19, Santa Monica
          Residencial, Cali.
        </p>
      </LegalModal>
    </>;
}